import React from 'react';

import Link, { LinkProps } from 'atomic/link/link';

import './sidebar-list.scss';

interface ItemProps {
    title: string;
    url: string;
    className?: string;
}

const StaticSidebarList: React.FC<{ links: ItemProps[]; currentUrl: string; }> = ({ links, currentUrl }) => {
    const linkProps = (item: ItemProps): LinkProps => {
        const itemProps: LinkProps = {
            title: item.title,
            className: 'static-sidebar__link'
        };

        if (currentUrl !== item.url) {
            itemProps.href = item.url;
        }

        if (!item.url.match(/^\//)) {
            itemProps.target = '_blank';
            itemProps.rel = 'noopener';
        }

        return itemProps;
    };

    return (
        <ul className="static-sidebar__list">
            {
                links.map(item => (
                    <li key={item.title}>
                        <Link {...linkProps(item)}>
                            {item.title}
                        </Link>
                    </li>
                ))
            }
        </ul>
    );
};

export default StaticSidebarList;
